// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"35ea1dca","267":"4b98b546","271":"b36a82a9","373":"600a7626","516":"19df9674","540":"897ad079","598":"8b783db8","794":"a41443df","961":"d0efa03c"}[chunkId] + ".css";
};